<section>
    <div [ngClass]="isLastChild ? 'addons-last-child' : 'addons'">
        <div class="info">
            <div class="info-icon">
                <xm-media-image aria-hidden="true" [imageOptions]="displayImage" size="auto"></xm-media-image>
            </div>
            <div class="addon">
                <p class="plan-name">{{ pageData.title }}</p>
                <ng-container *ngIf="videoInfo.isPendingDenialState; else successState">
                    <p class="pending-description">{{ pageData.pendingDenialState.content }}</p>
                </ng-container>
                <ng-template #successState>
                    <p class="plan-subtitle">{{ videoDefinition.subtitle }}</p>
                    <p class="plan-description">{{ description }}</p>
                </ng-template>
            </div>
            <div class="action">
                <button class="xm-btn-secondary-light"
                    (click)="switchOnResolution()"
                    [disabled]="shouldDisableButton"
                    [ngClass]="{'disabled': shouldDisableButton}">
                    {{ buttonCTA }} <span class="accessibility-hidden">{{ pageData.title }}</span>
                </button>
            </div>
        </div>
    </div>
</section>
